import { render } from "./PaymentOnPublished.vue?vue&type=template&id=cc76f480"
import script from "./PaymentOnPublished.vue?vue&type=script&lang=js"
export * from "./PaymentOnPublished.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__